<template>
    <div>
        <p class="merchaName">*商户信息</p>
        <p>
            <label>
                商户名称:
            </label>
            <el-input placeholder="请输入商户名称" class="tailhead" v-model="input" clearable></el-input>
        </p>
        <p>
            <label>
                地址:
            </label>
            <el-cascader :props="props" class="address"></el-cascader>
        </p>
         <p>
            <label class="addressLabel">
                详细地址:
            </label>
            <el-input type="textarea" :rows="1" class="addressText" placeholder="请填写具体到门牌号" v-model="textarea"> </el-input>
        </p>
        <p class="merchaTel">
            <label >
                电话区号:
            </label>
            <el-input placeholder="国家区号" class="telInputDuan"  v-model="input" clearable></el-input>
            <label >
                联系电话:
            </label>
            <el-input placeholder="固定号码或者手机号" class="telInput" v-model="input" clearable></el-input>
            <label >
                请输入联系电话，审核时可能需要进行电话核实
            </label>
        </p>
        <p>
            <div class="runA">运营资质:</div>
            <el-upload class="runB"
                action="https://jsonplaceholder.typicode.com/posts/"
                list-type="picture-card"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove">
                <i class="el-icon-plus"></i>
            </el-upload>
            <!-- <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog> -->
            <div class="runC">
                <p>请上传营业资质证明照片，如营业执照、授权书等。</p>
                <p>上传图片格式要求:PNG、JPG、无大小限制</p>
            </div>
        </p>

        <p class="registerName">*注册人信息</p>
        <p>
            <label>
                真实姓名:
            </label>
            <el-input placeholder="请输入真实姓名" class="tailhead" v-model="input" clearable></el-input>
        </p>
         <p class="merchaTel">
            <label >
                电话区号:
            </label>
            <el-input placeholder="国家区号" class="telInputDuan"  v-model="input" clearable></el-input>
            <label >
                联系电话:
            </label>
            <el-input placeholder="固定号码或者手机号" class="telInput" v-model="input" clearable></el-input>
            <label >
                请输入联系电话，审核时可能需要进行电话核实
            </label>
        </p>
            <p>
                <el-checkbox v-model="checked">我同意并遵守<a class="agrement">《七鸥鸥商家管理系统服务协议》</a></el-checkbox>
            </p>
            <p>
                <el-button type="primary" class="tailRegister">提交审核</el-button>
            </p>
    </div>    
</template>

<script>

    let id = 0;
export default {
    data(){
     return {
        textarea:'',
        props: {
          lazy: true,
          lazyLoad (node, resolve) {
            const { level } = node;
            setTimeout(() => {
              const nodes = Array.from({ length: level + 1 })
                .map(item => ({
                  value: ++id,
                  label: `选项${id}`,
                  leaf: level >= 2
                }));
              // 通过调用resolve将子节点数据返回，通知组件数据加载完成
              resolve(nodes);
            }, 1000);
          }
        },
        dialogImageUrl: '',
        dialogVisible: false
      };
    },
    methods:{
        handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      }
    }
}
</script>

<style scoped>

.merchaName{
    margin-right: 71%;
}

.tailhead{
    width: 20%;
    margin-right: 50%;
}

.address{
    margin-right: 52.5%;
}

.addressLabel{
    /* padding-bottom: 10%; */
    line-height: 2;
}
.addressText{
    width: 20%;
    margin-right: 50%;
}
.merchaTel{
    margin-right: 16%;
}


.runA{
    float: left;
    margin-left: 12%;
}
.runB{
    float: left;
    margin-left: 1%;
}
.runC{
    margin-right: 40%;
    color: #909399;
    padding-top: 1%;
}

.registerName{
    margin-top:5%;
    margin-right: 71%;
    clear:both;
}


.telInputDuan{
    width: 10%;
}

.telInput{
    width: 20%;
}

.agrement{
    color: #409EFF;
}
.tailRegister{
    margin-left: 4%;
    width: 25%;
}

</style>


// WEBPACK FOOTER //
// src/components/Register/MerchantInfo.vue